import dynamic from 'next/dynamic'

export const DynamicConsistentCharacterModal = dynamic(
  () => import('./ConsistentCharacterModal'),
  {
    ssr: false,
  },
)
